import React, { useEffect, useState } from 'react';
import { Button } from 'reactstrap';
import { isExpired, isReverting, msRemaining } from '../../services/impersonation';

const formatCountdown = (ms) => {
    const totalSeconds = Math.ceil(ms / 1000);
    return `${Math.floor(totalSeconds / 60)}:${String(totalSeconds % 60).padStart(2, '0')}`;
};

// The impersonation warning bar, and the clock the admin can see. It owns its own tick so
// a once-a-second countdown re-renders this bar and nothing else. Layout keeps a slower
// safety net for the cases a tab-local timer can't cover (sleep, background throttling,
// another tab).
const ImpersonationBanner = ({ user, onStop }) => {
    const [timeLeft, setTimeLeft] = useState(() => msRemaining());

    useEffect(() => {
        const tick = () => {
            if (isReverting()) return;
            if (isExpired()) {
                onStop('expired');
                return;
            }
            setTimeLeft(msRemaining());
        };

        const interval = setInterval(tick, 1000);
        return () => clearInterval(interval);
    }, [onStop]);

    return (
        <div className="impersonating-container position-fixed w-100 h-100 top-0 start-0 d-flex flex-column">
            <div className="flex-grow-1"></div>
            <div className="toolbar d-flex align-items-center px-3 text-black justify-content-between">
                <span className="lead text-white fw-bold text-uppercase d-none d-md-inline-block">
                    <span className="fas fa-warning me-2 text-warning"/>
                    WARNING
                </span>

                <span className="lead text-white fw-bold text-uppercase">
                    <span className="d-none d-md-inline-block">Impersonating as</span> {user.firstName} {user.lastName}
                </span>

                <span className="lead text-white fw-bold text-uppercase d-none d-md-inline-block">
                    {user.parentOrganization?.name}
                </span>

                <span className="text-white fw-bold" title="Impersonation ends automatically">
                    <span className="fas fa-clock me-2"/>{formatCountdown(timeLeft)}
                </span>

                <Button color="light" onClick={() => onStop('manual')}>
                    <span className="fas fa-stop text-danger me-2"/>Stop
                </Button>
            </div>
        </div>
    );
};

export default ImpersonationBanner;
